module.exports = __webpack_public_path__ + "img/gold_bobocoin.gm.b1ec8a4.png";